export default "__VITE_ASSET__1RyCVzDg__"